import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/7_2.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Zdobione wrota"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p19,
            }}
            content={
                <div>
                    <ul>
                        <li>Piękne bramy macie, rzadko się widuje taki wzór na zdobieniach…</li>
                        <li>A to taka lokalna tradycja, niemiecka. Mamy najlepszych stolarzy w województwie, a może i w kraju! Będzie już kilka lat, jak ten mój domek postawiliśmy, a tam – kantor pokazuje przez okno na dzwonnicę – nowiutki dzwon! Dzieje się u nas w Zagórowie!</li>
                    </ul>
                </div>
            }
        />

    );
}